module.exports = __webpack_public_path__ + "static/img/5.ce8aea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/growthThinking/list7/5.png
// module id = a+Tg
// module chunks = 1